import { sql } from "drizzle-orm";
import {
  check,
  index,
  integer,
  jsonb,
  pgTable,
  text,
  timestamp,
} from "drizzle-orm/pg-core";

// A standalone room calendar: deliberately no link to pupils, lessons, tutors,
// School Day, invoices or Amelia. Hub identity only authorises its administrator.
export const caldayRoomSettings = pgTable(
  "calday_room_settings",
  {
    id: text("id").primaryKey(),
    passwordHash: text("password_hash"),
    passwordVersion: integer("password_version").notNull().default(0),
    termStart: text("term_start").notNull().default(""),
    termEnd: text("term_end").notNull().default(""),
    openStart: integer("open_start").notNull().default(480),
    openEnd: integer("open_end").notNull().default(1080),
    openDays: text("open_days").notNull().default("1,2,3,4,5"),
    ready: integer("ready").notNull().default(0),
  },
  (t) => [
    check(
      "calday_room_settings_hours",
      sql`${t.openStart} >= 0 and ${t.openEnd} <= 1440 and ${t.openEnd} > ${t.openStart}`,
    ),
  ],
);
export const caldayRoomRegular = pgTable(
  "calday_room_regular",
  {
    id: text("id").primaryKey(),
    roomId: text("room_id"),
    owner: text("owner").notNull().default(""),
    weekday: integer("weekday").notNull(),
    start: integer("start").notNull(),
    end: integer("end").notNull(),
    teacher: text("teacher").notNull(),
    label: text("label").notNull(),
  },
  (t) => [
    check(
      "calday_room_regular_room",
      sql`${t.roomId} is null or ${t.roomId} in ('room-1', 'room-2', 'room-3', 'studio')`,
    ),
    check(
      "calday_room_regular_hours",
      sql`${t.weekday} between 0 and 6 and ${t.start} >= 0 and ${t.end} <= 1440 and ${t.end} > ${t.start}`,
    ),
  ],
);
export const caldayRoomBookings = pgTable(
  "calday_room_bookings",
  {
    id: text("id").primaryKey(),
    roomId: text("room_id"),
    date: text("date").notNull(),
    endDate: text("end_date"),
    openEnded: integer("open_ended").notNull().default(0),
    exceptionType: text("exception_type"),
    start: integer("start").notNull(),
    end: integer("end").notNull(),
    teacher: text("teacher").notNull(),
    purpose: text("purpose").notNull(),
    kind: text("kind").notNull().default("extra"),
    owner: text("owner").notNull(),
    version: integer("version").notNull().default(1),
    createdAt: timestamp("created_at", { withTimezone: true })
      .notNull()
      .defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
      .notNull()
      .defaultNow(),
    cancelledAt: timestamp("cancelled_at", { withTimezone: true }),
  },
  (t) => [
    check(
      "calday_room_booking_room",
      sql`${t.roomId} is null or ${t.roomId} in ('room-1', 'room-2', 'room-3', 'studio')`,
    ),
    check(
      "calday_room_booking_hours",
      sql`${t.start} >= 0 and ${t.end} <= 1440 and ${t.end} > ${t.start}`,
    ),
    check(
      "calday_room_booking_kind",
      sql`${t.kind} in ('extra', 'closure', 'absence', 'room_use')`,
    ),
    index("calday_room_booking_date_idx").on(t.date, t.cancelledAt),
  ],
);
export const caldayRoomStaff = pgTable("calday_room_staff", {
  subject: text("subject").primaryKey(),
  username: text("username").notNull().unique(),
  name: text("name").notNull(),
  enabled: integer("enabled").notNull().default(1),
  accessVersion: integer("access_version").notNull().default(1),
  roomManager: integer("room_manager").notNull().default(0),
  regularVersion: integer("regular_version").notNull().default(0),
  regularConfirmedAt: timestamp("regular_confirmed_at", { withTimezone: true }),
});
export const caldayRoomSessions = pgTable(
  "calday_room_sessions",
  {
    id: text("id").primaryKey(),
    subject: text("subject").notNull(),
    name: text("name").notNull(),
    passwordVersion: integer("password_version").notNull(),
    staffVersion: integer("staff_version").notNull().default(0),
    expires: timestamp("expires", { withTimezone: true }).notNull(),
  },
  (t) => [index("calday_room_session_expiry_idx").on(t.expires)],
);
export const caldayRoomLoginAttempts = pgTable("calday_room_login_attempts", {
  id: text("id").primaryKey(),
  attempts: integer("attempts").notNull(),
  expires: timestamp("expires", { withTimezone: true }).notNull(),
});
export const caldayRoomEvents = pgTable("calday_room_events", {
  id: text("id").primaryKey(),
  actor: text("actor").notNull(),
  action: text("action").notNull(),
  bookingId: text("booking_id"),
  before: jsonb("before"),
  after: jsonb("after"),
  createdAt: timestamp("created_at", { withTimezone: true })
    .notNull()
    .defaultNow(),
});
